import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  wine: {
    marginBottom: theme.spacing(2)
  },
  summary: {
    backgroundColor: theme.backgroundColor
  },
  label: {
    width: 200
  },
  editWine: {
    position: 'relative',
    width: '100%'
  },
  button: {
    position: 'absolute',
    right: 15,
    top: -5
  }
}))

export {
  useStyles
}